import { useEffect, useState } from 'react';
import { Select } from 'common/components';
import { useUpdateContactStatus } from 'services/hooks/mutations';
import { useGetPartyStages } from 'services/hooks/queries';

export const StatusSelect = ({ contactId, currentStatus }: { contactId: string; currentStatus?: string }) => {
    const { updateContactStatus, isPending } = useUpdateContactStatus();
    const [selectedStatus, setSelectedStatus] = useState(currentStatus);
    const { partyStages } = useGetPartyStages();

    useEffect(() => {
        setSelectedStatus(currentStatus);
    }, [currentStatus]);

    const handleStatusChange = async (newStatus: string) => {
        setSelectedStatus(newStatus);

        await updateContactStatus(
            { id: contactId, status: newStatus, note: '' },
            {
                onError: () => {
                    setSelectedStatus(currentStatus);
                },
            }
        );
    };

    const statusOptions =
        partyStages?.data.map((status) => ({
            value: status,
            label: status,
        })) || [];

    return (
        <Select
            options={statusOptions}
            value={selectedStatus}
            size='sm'
            onChange={(e) => handleStatusChange(e.target.value)}
            isLoading={isPending}
            style={{ minWidth: '120px' }}
        />
    );
};
